<template>
	<div class="order">
		<div v-wechat-title="$route.meta.title"></div>
		<TopBar></TopBar>
		<div style="display: flex; width: 100%; flex-direction: column;align-items: center;">
			<div style="width: 85%; height: 60px; background-color: #FFFFFF; display: flex;align-items: center; padding: 0 30px; margin-top: 0px;">
				<div style="color: #277dd3; cursor: pointer;" class="icon iconfont icon-ffanhui-" @click="prev">返回</div>
			</div>
			<div style="width: 85%;  background-color: #FFFFFF; margin-top: 10px; padding: 20px;">
				<div style="font-weight: bold; margin-bottom: 20px;">下单记录</div>
				<Table :data="list" :columns="columns">
					<div slot-scope="{ row }" slot="operation" style=" margin-top: 5px">
						<div v-if="row.status != -1">--</div>
						<div v-else @click="pay" :data-id="row.id">去支付</div>
					</div>
				</Table>
			</div>
			<div style="display: flex;justify-content: flex-end;width: 85%; margin-top: 10px;">
				<Page :total="count" :current="page" @on-change="changePage" :page-size="20" show-total/>
			</div>
		</div>
		<Modal v-model="choosePay" width='500' title="支付订单">
			<div>
				<div class="fx-flex"><div>标题：</div><div>{{payItem.ext_info.title}}</div></div>
				<div class="fx-flex"><div>订单号：</div><div>{{payItem.tid}}</div></div>
				<div class="fx-flex"><div>支付金额：</div><div>{{payItem.money}}元</div></div>
				<div class="fx-flex">
					<div>
						支付方式：
					</div>
					<div>
						<RadioGroup v-model="payType">
							<Radio :label="1"><span>支付宝</span></Radio>
							<Radio :label="2"><span>微信</span></Radio>
						</RadioGroup>
					</div>
				</div>
			</div>
			<div slot="footer">
				<Button type="primary" @click="toPay()">确定</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import TopBar from '../topbar/TopBar.vue'
	import {mapGetters} from "vuex";
	import {getOrderList, getOrder, payOrder} from '@/api/order'

	export default {
		name: "Order",
		components: {
			TopBar
		},
		mounted() {
			this.getList();
		},
		computed:{
			...mapGetters(['token'])
		},
		data() {
			return {
				count: 0,
				page: 1,
				payType: 1,
				list: [],
				payItem: {ext_info:{}},
				choosePay: false,
				columns: [{
					title: '订单内容',
					key: 'content'
				},
					{
						title: '金额',
						key: 'money'
					},
					{
						title: '下单时间',
						key: 'created_at'
					},
					{
						title: '状态',
						key: 'status_name'
					},
					{
						title: '操作',
						slot: 'operation'
					}
				],
			}
		},
		methods: {
			async getList() {
				let that = this;
				let data = {token:this.token, page:this.page};
				var res = await getOrderList(that, data);
				if (res.code == 1) {
					if (that.page == 1) {
						that.list = res.data.list;
					} else {
						res.data.list.forEach(function (row) {
							that.list.push(row);
						})
					}
					that.count = res.count;
				}
			},
			changePage(e) {
				this.page = e;
				this.getList();
			},
			pay(e) {
				let that = this;
				let data = {token:this.token, id:e.currentTarget.dataset.id};
				this.throttle(async function () {
					var res = await getOrder(that, data);
					if (res.code == 1) {
						that.payItem = res.data.item;
						that.choosePay = true;
					}
				}, 500)
			},
			toPay() {
				let that = this;
				let data = {token: this.token, id: that.payItem.id, payType: that.payType}
				that.throttle(async function () {
					var res = await payOrder(that, data);
					if (res.code == 1) {
						that.choosePay = false;
					}
				}, 500)
			},
			prev() {
				this.$router.go(-1)
			}
		}
	}
</script>

<style scoped lang="less">
	.order {
		height: 100%;
		width: 100%;
		background-color: #F5F7F9;
	}
	.fx-flex{
		display: flex;
		justify-content: space-between;
		padding: 5px 0;
	}
</style>
